const MainView = require("./main-view.js");

module.exports = function TutorialView(state, emit) {
  emit("set-playing-tutorial", true);
  const resultingView = MainView(state, emit);
  applyTutorialHighlighting(resultingView);
  applyTutorialDisabledElements(resultingView);
  return resultingView;

  function applyTutorialHighlighting(html) {
    if (
      state.currentTutorial &&
      state.currentTutorial[state.currentTutorialStep]
    ) {
      const step = state.currentTutorial[state.currentTutorialStep];
      if (step.highlights && step.highlights.htmlElements) {
        step.highlights.htmlElements.forEach((queryString) => {
          const element = html.querySelector(queryString);
          if (element) {
            element.classList.add("highlighted");
          } else {
            console.warn("could not find highlight element", queryString);
          }
        });
      }
      return html;
    }
  }

  function applyTutorialDisabledElements(html) {
    if (
      state.currentTutorial &&
      state.currentTutorial[state.currentTutorialStep]
    ) {
      const step = state.currentTutorial[state.currentTutorialStep];
      if (step.disabledElements) {
        step.disabledElements.forEach((selector) => {
          const element = html.querySelector(selector);
          if (element) {
            element.classList.add("disabled");
          } else {
            console.warn("could not find element to disable:", selector);
          }
        });
      }
      return html;
    }
  }
};
